const isDefined = (param) => param !== null && param !== undefined;

export { isDefined as i };
//# sourceMappingURL=isDefined-e6be1a49.js.map
